<template>
  <div :class="['task-card-modal', { 'modal-invisible': invisible, 'modal-mq-sm': $mq === 'sm' }]">
    <div v-if="taskCard">
      <div class="task-card-modal-header">
        <proa-project-label
          v-if="projectLabel"
          :title="projectLabel.title"
          :color="projectLabel.color"
        />
        <div v-else></div>
        <span class="close-button" @click="$emit('closeTaskCardModal')">
          <img :src="require('@/assets/images/icons/cross_sm.png')"/>
        </span>
      </div>
      <div class="title">{{ taskCard.title }}</div>
      <div class="period">
        <span>{{ $t('models.taskCard.period') }}：</span>
        <span v-if="!taskCard.startAt && !taskCard.endAt">{{ $t('models.taskCard.placeHolders.period') }}</span>
        <span v-else :class="{ 'overdue': overdue }">
          {{ taskCard.startAt | moment('MM月DD日') }}〜{{ taskCard.endAt | moment('MM月DD日') }}
        </span>
      </div>
      <div class="progress-rate">
        <span>{{ $t('models.taskCard.attributes.progress') }}：</span>
        <span :class="{ 'overdue': overdue }">
          {{ taskCard.progress }}%
        </span>
      </div>
      <div v-if="users.length" class="members">
        <div v-for="user in users" :key="user.id" class="avatar-wrapper">
          <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="xs"/>
        </div>
      </div>
      <div class="button-wrapper">
        <proa-button @click.native="onClickTaskCardDetail">
          {{ $t('common.detail') }}
        </proa-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TaskCardModal',
  props: {
    taskCard: Object,
    invisible: Boolean
  },
  computed: {
    overdue: function() {
      return this.taskCard.progress != 100 && moment(this.taskCard.endAt).isSameOrBefore(moment(new Date()))
    },
    projectLabel: function() {
      return this.taskCard.projectLabels[0]
    },
    users: function() {
      return this.taskCard.users
    }
  },
  methods: {
    onClickTaskCardDetail: function() {
      this.$router.push({ name: 'showProjectTaskCards', params: {
        projectId: this.taskCard.projectId,
        id: this.taskCard.id,
        returnMenu: 'ganttChart'
      }})
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.task-card-modal {
  width: 260px;
  height: 230px;
  position: absolute;
  background-color: white;
  box-shadow: 0px 0px 4px #00000026;
  border-radius: 4px;
  padding: 15px;
  z-index: 2;

  &.modal-mq-sm {
    // モバイルの場合は画面中央の最前面に表示
    z-index: 4;
    position: fixed !important;
    inset: 0 !important;
    margin: auto !important;
  }

  &.modal-invisible {
    visibility: hidden !important;
    position: fixed !important;
  }

  .task-card-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;

    .close-button {
      width: 10px;
      height: 10px;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;

      img {
        width: 10px;
        height: 10px;
      }
    }
  }

  .title {
    font-weight: 600;
    margin-bottom: 10px;
    padding-right: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .members {
    margin-top: 10px;
    display: flex;
    overflow: auto;

    .avatar-wrapper {
      margin: 0 5px 5px 0;
    }
  }

  .period, .progress-rate {
    font-size: 12px;

    .overdue {
      color: $error-color;
    }
  }

  .button-wrapper {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);

    button {
      height: 34px;
    }
  }
}
</style>
